// removed by extract-text-webpack-plugin
module.exports = {"avatarList":"antd-pro-avatarList","avatarItem":"antd-pro-avatarItem","avatarItemLarge":"antd-pro-avatarItemLarge","avatarItemSmall":"antd-pro-avatarItemSmall","avatarItemMini":"antd-pro-avatarItemMini"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/AvatarList/index.less
// module id = 361
// module chunks = 0 1